import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, RecaptchaVerifier } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';

// The same Firebase project as the apps (uhplus-15c36 is staging). Job seekers sign in
// by email link; everything goes through the jobs* / seeker* callables
// (functions/src/marketJobs.ts). The web API key is not a secret.
const app = initializeApp({
  apiKey: 'AIzaSyCpwMRUaCFbn6yvH98zYDQuW-YXGTsz3jY',
  authDomain: 'uhplus-15c36.firebaseapp.com',
  // Local QA only (e2e/web): REACT_APP_EMULATOR=1 points at the demo-laundry emulators.
  projectId: process.env.REACT_APP_EMULATOR === '1' ? 'demo-laundry' : 'uhplus-15c36',
  storageBucket: 'uhplus-15c36.firebasestorage.app',
  messagingSenderId: '933833049999',
  appId: '1:933833049999:web:0160ad07ca68141436edfa',
});
export const auth = getAuth(app);
const functions = getFunctions(app, 'us-central1');
if (process.env.REACT_APP_EMULATOR === '1') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9641', { disableWarnings: true });
  // No real reCAPTCHA against the emulator: verify() hands back a test token.
  auth.settings.appVerificationDisabledForTesting = true;
  connectFunctionsEmulator(functions, '127.0.0.1', 5641);
}
export const call = async <T = any, R = any>(name: string, data?: T): Promise<R> => (await httpsCallable<T, R>(functions, name)(data as T)).data;


/** A callable's message, if it was written for people. */
export function errText(e: any, fallback = 'Something went wrong. Please try again.'): string {
  const m = String(e?.message ?? '').replace(/^\[?[a-z-]+\/[a-z-]+\]?\s*/i, '').trim();
  if (!m || /^[A-Z_ -]+$/.test(m) || m.length > 240) return fallback;
  return m;
}

// A single-use reCAPTCHA token for a phone code the SERVER sends (webSendPhoneCode).
// Firebase won't text a web-originated code without one. Rendered into a fresh child
// each time: grecaptcha refuses to render twice into one element, so a failed first
// try would otherwise break every retry until a reload (same as src/auth/mfa.ts).
let recaptchaSeq = 0;
export async function recaptchaToken(hostId: string): Promise<string> {
  const host = document.getElementById(hostId);
  if (!host) throw new Error('Reload the page and try again.');
  host.innerHTML = '';
  const slot = document.createElement('div');
  slot.id = `${hostId}-${++recaptchaSeq}`;
  host.appendChild(slot);
  const verifier = new RecaptchaVerifier(auth, slot.id, { size: 'invisible' });
  try {
    return await verifier.verify();
  } finally {
    try { verifier.clear(); } catch { /* already cleared */ }
  }
}
